import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ConfirmExperience from './confirm_experience';
import EditExperience from './edit_experience';
import DoneBanner from '../done_banner';

const ExperienceBanner = ({ userID, years, removeBanner }) => {
  const [step, setStep] = useState(years ? 'confirm' : 'edit');
  const [action, setAction] = useState('');

  useEffect(() => {
    if (step === 'done') {
      setTimeout(removeBanner, 7000);
    }
  }, [step]);

  switch (step) {
    case 'confirm':
      return <ConfirmExperience years={years} setStep={setStep} setAction={setAction} />;
    case 'edit':
      return (
        <EditExperience userID={userID} years={years} setStep={setStep} setAction={setAction} />
      );
    case 'done':
      return <DoneBanner action={action} />;
    // No default
  }
};

ExperienceBanner.propTypes = {
  userID: PropTypes.number.isRequired,
  years: PropTypes.number,
  removeBanner: PropTypes.func.isRequired,
};

export default ExperienceBanner;
